module.exports = __webpack_public_path__ + "img/city5.098af52d.png";